import { render, staticRenderFns } from "./ListagemSelosGerenciador.vue?vue&type=template&id=8418d322&scoped=true&"
import script from "./ListagemSelosGerenciador.vue?vue&type=script&lang=js&"
export * from "./ListagemSelosGerenciador.vue?vue&type=script&lang=js&"
import style0 from "./ListagemSelosGerenciador.vue?vue&type=style&index=0&id=8418d322&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8418d322",
  null
  
)

export default component.exports